const SUPPORTED_LANGUAGES: Record<string, string> = {
  "zh-Hans": "简体中文", // Simplified Chinese
//   "zh-Hant": "繁體中文", // Traditional Chinese
//   ja: "日本語",  // Japanese
//   ko: "한국어", // Korean
//   id: "Bahasa Indonesia", // Indonesian
//   hi: "हिन्दी", // Hindi
  en: "English", // English, default
//   es: "Español", // Spanish
//   fr: "Français", // French
//   it: "Italiano", // Italian
//   pt: "Português", // Portuguese
//   ru: "Русский", // Russian
} as const;

export default SUPPORTED_LANGUAGES;